const MensajeError = (mensaje) => {
  return (
    <span className='campo-error' > <i class="bi bi-exclamation-diamond"></i> {mensaje}</span>
  )
}

export default MensajeError